import { useMemo, useState, useRef } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";

export default function Flags({ images = [] }) {
  // allow ["url"] or [{ src, alt }]
  const slides = useMemo(
    () =>
      images.map((img) =>
        typeof img === "string"
          ? { src: img, alt: "Flag" }
          : { src: img.src, alt: img.alt || "Flag" }
      ),
    [images]
  );

  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const swiperRef = useRef(null);

  if (!slides.length) return null;

  return (
    <div className="tgrid">
      {/* Grid */}
      {/* {slides.map((s, i) => (
        <button
          key={i}
          className="tgrid__item"
          type="button"
          onClick={() => {
            setIndex(i);
            setOpen(true);
          }}
          aria-label={`Open testimonial ${i + 1}`}
        >
          <img src={s.src} alt={s.alt} loading="lazy" />
        </button>
      ))} */}

    <div className="testimonial_swiper_wrap">
        <div className="testimonial_main_container">
            <div className="navArrow navArrow--left is-hint">
                <AiOutlineArrowLeft  style={{ color: "#ffffff" }}
                    onClick={() => swiperRef.current?.slidePrev()}
                />
            </div>
            <Swiper
                spaceBetween={12}
                slidesPerView={2}           // ✅ mobile default
                slidesPerGroup={1}          // ✅ move by 2 on mobile
                breakpoints={{
                    480: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 12 },
                    768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 20 },
                    1024: { slidesPerView: 4, slidesPerGroup: 1, spaceBetween: 20 },
                }}
                // slidesPerView="auto"
                style={{ paddingBottom: 8 }}
                onBeforeInit={(swiper) => {
                    swiperRef.current = swiper;
                }}
            >
                {slides.map((s, i) => (
                    <SwiperSlide key={i} style={{ width: 220 }}>
                        <div sx={{ borderRadius: 2 }}>
                            <div className="flags_item" key={`g1-${i}`}>
                                <img src={s.src} alt={s.alt} />
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="navArrow navArrow--right is-hint">
                <AiOutlineArrowRight style={{ color: "#ffffff" }}
                    onClick={() => swiperRef.current?.slideNext()}
                />
            </div>
        </div>
      </div>
    </div>
  );
}
